import { render, staticRenderFns } from "./Unidad.vue?vue&type=template&id=23881fea&"
import script from "./Unidad.vue?vue&type=script&lang=js&"
export * from "./Unidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports